import React, { FC } from 'react'
import { RouterProvider } from 'react-router-dom'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Router } from '@remix-run/router'

type Props = {
    router: Router
}

export const Main: FC<Props> = ({ router }: Props) => (
    <div className='router-main-container'>
        <RouterProvider router={router} />
    </div>
)
